import { IPlayer } from '../../../modules/sport/interfaces/game';
import Image from '../../../common/Image';
import AvatarImg from '../images/avatar.svg';
import NegraFutbol from '../../../common/components/images/sports/futbol/negra.png';
import BlancaFutbol from '../../../common/components/images/sports/futbol/blanca.png';

import NegraPadel from '../../../common/components/images/sports/padel/negra.png';
import BlancaPadel from '../../../common/components/images/sports/padel/blanca.png';

import NegraTenis from '../../../common/components/images/sports/tenis/negra.png';
import BlancaTenis from '../../../common/components/images/sports/tenis/blanca.png';

import NegraBasquetbol from '../../../common/components/images/sports/basquetbol/negra.png';
import BlancaBasquetbol from '../../../common/components/images/sports/basquetbol/blanca.png';

import { useAuth } from '../../../context/auth-context';
interface TeamProps {
    color?: string;
    players?: Array<IPlayer>;
    text?: string;
    contrast?: string;
    colorTeam?: string;
    capacity?: number;
    sport?: string;
}

const shirt = {
    futbol: {
        black: NegraFutbol,
        while: BlancaFutbol,
    },
    padel: {
        black: NegraPadel,
        while: BlancaPadel,
    },
    basquetbol: {
        black: NegraBasquetbol,
        while: BlancaBasquetbol,
    },
    tenis: {
        black: NegraTenis,
        while: BlancaTenis,
    },
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function Team(props: TeamProps): JSX.Element {
    const { players, color, text, contrast, colorTeam, capacity, sport } = props;
    const auth = useAuth();

    const role = auth?.user?.role || 'PLAYER';
    const cantPlayersNew = players && players.length < capacity / 2 ? capacity / 2 - players.length : 0;
    const playersNew: IPlayer[] = [];

    for (let i = 0; i < cantPlayersNew; i++) {
        playersNew.push({
            id: i + '-Id',
        });
    }
    return (
        <div className={`relative w-full mt-4  md:px-0 pb-10 md:pb-0 ${color} shadow-xl `}>
            <div className="relative z-20 w-full md:px-0  md:pb-0 ">
                {players && players.length > 0 ? (
                    players.map((player, i) => {
                        return (
                            <div
                                className={`${i % 2 ? contrast : color} ${
                                    i === 0 || (i === players.length - 1 && '')
                                }  `}
                                key={`player-${i}-${player.id}`}
                            >
                                <div className="px-2 flex space-x-4 relative ">
                                    <div className="col-start-1 row-start-3 min-h-teamMovil  px-1 md:px-4 md:min-h-team">
                                        {player.name && (
                                            <div className="flex items-center text-sm font-medium">
                                                <Image
                                                    className={`z-0 w-1/2 py-2 h-1/2 md:h-full  mr-1 sm:mr-0 md:w-20 `}
                                                    imgClassName={`z-0 rounded-full  ${
                                                        player.status === 'PENDING' && role === 'ADMIN'
                                                            ? 'border-2 border-sm-tourney'
                                                            : ''
                                                    }`}
                                                    src={player.photo ? player.photo : AvatarImg}
                                                    alt="player"
                                                    width={70}
                                                    height={64}
                                                />
                                                <div
                                                    className={`${
                                                        color === ' bg-black ' ? (i % 2 ? 'text-black' : text) : text
                                                    }  py-4 md:py-2 font-bold  `}
                                                >
                                                    {player.name}
                                                    {player.status === 'PAID' ? (
                                                        <div className="absolute group top-1 md:top-1/3 right-1">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                className="h-6 w-6 absolute top-1/3 right-4 bg-green-500 rounded-full"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke="currentColor"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth="2"
                                                                    d="M5 13l4 4L19 7"
                                                                />
                                                            </svg>
                                                            <div className="absolute top-0 right-12  w-32 flex-col hidden items-center  mb-14 group-hover:flex">
                                                                <span className="relative z-10  p-2 text-xs leading-none text-white whitespace-no-wrap bg-sm-blue-primary  shadow-lg rounded-md ">
                                                                    Pago realizado
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="absolute group top-1 md:top-1/3 right-1">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                className="h-4 w-4 md:h-6 md:w-6 absolute group top-1 md:top-1/3 right-1 md:right-4 bg-yellow-500 rounded-full"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke="currentColor"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth="2"
                                                                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                                                />
                                                            </svg>
                                                            <div className="absolute top-0 right-12  w-32 flex-col hidden items-center  mb-14 group-hover:flex">
                                                                <span className="relative z-10  p-2 text-xs leading-none text-white whitespace-no-wrap bg-sm-blue-primary  shadow-lg rounded-md ">
                                                                    En espera de Pago
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div> </div>
                )}
                {playersNew &&
                    playersNew.length > 0 &&
                    playersNew.map((player, i) => {
                        return (
                            <div
                                className={`${
                                    i % 2
                                        ? players.length % 2
                                            ? color
                                            : contrast
                                        : players.length % 2
                                        ? contrast
                                        : color
                                }`}
                                key={`player-2-${i}`}
                            >
                                <div className="px-2 flex space-x-4 relative ">
                                    <div className="col-start-1 row-start-3 px-1  md:px-4  min-h-teamMovil md:min-h-team">
                                        <div className="flex items-center text-sm font-medium">
                                            <Image
                                                className={`z-0 w-1/2 py-2 h-1/2 md:h-full  mr-1 sm:mr-0 md:w-20 `}
                                                imgClassName={`z-0 opacity-10 rounded-full`}
                                                src={AvatarImg}
                                                alt="player"
                                                width={70}
                                                height={64}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
            <Image
                className="z-0 center"
                src={colorTeam === 'black' ? shirt[sport].black : shirt[sport].while}
                alt="Fondo"
                layout="fill"
                objectPosition="center"
                imgClassName="absolute ml-auto mr-auto left-0 right-0  text-center opacity-50"
            />
        </div>
    );
}
